import { unstable_batchedUpdates } from 'react-dom'

export const batch = unstable_batchedUpdates
